import { PermissionUserManagement } from "../../config";
import { getDataFromToken } from "@iso/lib/helpers/utility";
var UserDetails = getDataFromToken();
var roleOfUser = UserDetails.role;
const options = [
  {
    key: "category",
    label: "Categories",
    leftIcon: "ion-network",
    children: [
      {
        key: "categorytree",
        url: "categorytree",
        label: "Tree",
      },
      {
        key: "switch",
        url: "switch",
        label: "Switches",
      },
      {
        key: "export",
        url: "export",
        label: "Export",
      },
      {
        key: "dataextract",
        url: "dataextract",
        label: "Data Extract",
      },
    ],
  },
  {
    key: "labels",
    label: "Labels",
    leftIcon: "ion-pricetag",
    children: [
      {
        key: "categories",
        url: "categories",
        label: "Categories",
      },
      {
        key: "categorylabels",
        url: "categorylabels",
        label: "Category Labels",
      },
      {
        key: "labelgroups",
        url: "labelgroups",
        label: "Label Groups",
      },
      {
        key: "exportlabel",
        url: "exportlabel",
        label: "Export",
      },
    ],
  },
  {
    key: "products",
    label: "Products",
    leftIcon: "ion-android-restaurant",
    children: [
      {
        key: "infusion",
        url: "infusion",
        label: "Infusion",
      },
      {
        key: "CLM",
        url: "list-of-master/CLM",
        label: "Claims",
      },
      {
        key: "CLF",
        url: "list-of-master/CLF",
        label: "Claims Classification",
      },
      {
        key: "ALG",
        url: "list-of-master/ALG",
        label: "Allergens",
      },
      {
        key: "ACLF",
        url: "list-of-master/ACLF",
        label: "Allergen Group",
      },
      {
        key: "R",
        url: "list-of-master/R",
        label: "Retailers",
      },
      {// New store tab
        key: "S",
        url: "list-of-master/S",
        label: "Stores",
      },
      {
        key: "listSource",
        url: "listSource",
        label: "Source",
      },
      {
        key: "BRD",
        url: "list-of-brand-manufacturer/BRD",
        label: "Brands",
      },
      {
        key: "MNF",
        url: "list-of-brand-manufacturer/MNF",
        label: "Manufacturers",
      },
      {
        key: "exportmaster",
        url: "exportmaster",
        label: "Export",
      },
    ],
  },
  {
    key: "country",
    label: "Countries",
    leftIcon: "ion-earth",
    children: [
      {
        key: "listCountry",
        url: "listCountry",
        label: "List",
      },
    ],
  },
];
// if (roleOfUser === null || roleOfUser === "undefined" || roleOfUser === undefined || PermissionUserManagement.includes(roleOfUser)) {
if (PermissionUserManagement.includes(roleOfUser)) {
  options.push({
    key: "users",
    label: "User Management",
    leftIcon: "ion-person",
    children: [
      {
        key: "userlist",
        url: "userlist",
        label: "Users",
      },
    ],
  });
}

options.push({
  key: "logs",
  label: "Log Management",
  leftIcon: "ion-document",
  children: [
    {
      key: "logslist",
      url: "logslist",
      label: "User Logs",
    },
  ],
});
options.push(
  {
    key: "scheduled-downloads",
    label: "Generate App Database",
    url: "scheduled-downloads", // Add URL here for the parent
    leftIcon: "ion-settings",

  }
);
options.push(
  {
    key: "dev-management",
    label: "App Deployment",
    url: "dev-management",
    leftIcon: "ion-iphone",

  }
);



export default options;
